import PropTypes from 'prop-types';

/**
 * Slogan item definition
 */
export const SloganItem = PropTypes.shape({
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  category: PropTypes.string,
  tone: PropTypes.string,
  insight: PropTypes.string
});

/**
 * User input definition - expanded to match Figma design
 */
export const UserInputShape = PropTypes.shape({
  businessName: PropTypes.string.isRequired,
  industry: PropTypes.string.isRequired,
  location: PropTypes.string,
  description: PropTypes.string,
  uniqueSellingPoint: PropTypes.string,
  brandPersonality: PropTypes.string,
  preferredStyle: PropTypes.string
});

/**
 * Slogan generator results data structure
 * Validates data prop - allows empty/undefined slogans since component handles empty state
 * @param {object} props - Props object
 * @param {string} propName - Name of the prop being validated
 * @param {string} componentName - Name of the component
 * @returns {Error|null} - Error if validation fails, null otherwise
 */
export const SloganGeneratorResultsData = (props, propName, componentName) => {
  const { [propName]: data } = props;

  if (!data) {
    return new Error(`The prop '${propName}' is required in '${componentName}'.`);
  }

  // Validate slogans array structure if present (empty arrays are allowed for empty state)
  if (data.slogans !== undefined && !Array.isArray(data.slogans)) {
    return new Error(`The prop '${propName}.slogans' in '${componentName}' must be an array.`);
  }

  return null;
};

/**
 * Full data shape for SloganGeneratorResults
 */
export const SloganGeneratorDataShape = PropTypes.shape({
  slogans: PropTypes.arrayOf(SloganItem).isRequired,
  userInput: UserInputShape
});

/**
 * Available actions for SloganGeneratorResults
 * - 'generate_more': Show button to generate more slogans
 * - 'start_over': Show button to start over
 */
export const SloganGeneratorActions = PropTypes.arrayOf(
  PropTypes.oneOf(['generate_more', 'start_over'])
);

/**
 * Main SloganGeneratorResults props
 */
export const SloganGeneratorResultsProps = PropTypes.shape({
  data: SloganGeneratorResultsData,
  actions: SloganGeneratorActions,
  onComponentClick: PropTypes.func
});
